/**
 * @file
 * Scroll to ID.
 * Works well with MacOS and OSX.
 *
 * @url http://manos.malihu.gr/page-scroll-to-id/
 *
 * Add data attribut to set offset from the top in pixels
 * @example data-smooth-scroll-offset="200"
 */

const $scroll = $('[data-smooth-scroll]', context);

$scroll.once('scroll-to-id').each((index, el) => {
  const $this = $(el);
  const isSafari =
    !!navigator.userAgent.match(/safari/i) &&
    !navigator.userAgent.match(/chrome/i) &&
    typeof document.body.style.webkitFilter !== 'undefined' &&
    !window.chrome;

  let dataOffset = $this.data('smooth-scroll-offset');

  if (isSafari) {
    dataOffset += 100;
  }

  const options = {
    offset: dataOffset || 0,
  };

  $this.find('a').click(event => {
    event.preventDefault();
    $(event.target).mPageScroll2id(options);
  });
});
